import { useState } from 'react';
import dynamic from 'next/dynamic';
import { ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import { IInspirationProductImage } from '@features/cms/typescript';
import styles from '@components/InspirationProductImage/InspirationProductImage.styles';
import useBodyOverflow from '@hooks/useBodyOverflow';
import ProductGalleryBlockModalButton from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModalButton/ProductGalleryBlockModalButton';
import ProductGalleryBlockModal from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModal/ProductGalleryBlockModal';
import RenderMedia from '@utils/RenderMedia';
import { BLANK_VIDEO_OBJECT } from '@features/cms/const';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type ModalRootPortalProps = {
  children: ReactNode;
};
const DynamicModalRootPortal = dynamic<ModalRootPortalProps>(() => import('@components/ModalRootPortal/ModalRootPortal'), {
  ssr: false
});
type PropsType = {
  imageData: IInspirationProductImage;
};
const InspirationProductImage = ({
  imageData
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const [isHoverImage, setIsHoverImage] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const {
    variant,
    imageWithBlur,
    image,
    imageHover,
    products
  } = imageData;
  const imageVariant = variant || 'duoBigSquare';
  const imageSource = imageWithBlur || {
    image
  };
  const modalData = {
    products,
    image: imageSource,
    itemId: 'singleImage'
  };
  useBodyOverflow(isModalOpen, 'inspirationProductImage', false, true);
  const imageAlt = products[0]?.name || '';
  const renderImage = () => RenderMedia(image, BLANK_VIDEO_OBJECT, false, imageWithBlur, imageAlt, false);
  const hoverAlt = typeof imageHover !== 'string' && imageHover?.metadata?.alt || imageAlt || t('accessibility.productPhoto');
  const renderImageHover = () => imageHover !== null && <ResponsiveImage image={typeof imageHover === 'string' ? imageHover : imageHover?.path} className="image_hover" alt={hoverAlt} />;
  return products.length > 0 ? <>
      <button onMouseEnter={() => {
      setIsHoverImage(true);
    }} onMouseLeave={() => {
      setIsHoverImage(false);
    }} onClick={() => setModalOpen(true)} type="button" sx={styles.imageDuoBox(imageVariant)} className="photo_with_products" data-testid="inspirationProductImage-button">
        {renderImage()}
        {renderImageHover()}
        <ProductGalleryBlockModalButton isExpanded={isHoverImage} />
      </button>
      {isModalOpen && <DynamicModalRootPortal>
          <ProductGalleryBlockModal isActive={isModalOpen} slide={modalData} onClose={() => setModalOpen(false)} />
        </DynamicModalRootPortal>}
    </> : <div sx={styles.imageDuoBox(imageVariant)} data-testid="inspiration-product-image">
      {renderImage()}
      {renderImageHover()}
    </div>;
};
export default InspirationProductImage;